import actions from './actions';


export default {
  getParentCategories: actions.getParentCategories,
  getCategoryBySlug: actions.getCategoryBySlug,
};
